import fetch from '@/utils/fetch'

export const List = '/ali/saf/tags/get'

// 添加标签配置
export function createTag (data) {
  return fetch({
    url: '/ali/saf/tags/create',
    method: 'post',
    data
  })
}

//修改标签配置
export function updateTag (data) {
  return fetch({
    url: '/ali/saf/tags/update',
    method: 'post',
    data
  })
}

// 删除标签配置
export function deleteTag (data) {
  return fetch({
    url: `/ali/saf/tags/delete`,
    method: 'post',
    data
  })
}

// 修改分数配置
export function setScoreSettingInfo (query) {
  return fetch({
    url: '/ali/saf/score/update',
    method: 'post',
    data: query
  })
}

// 获取分数配置
export function getScoreSettingInfo (query) {
  return fetch({
    url: '/ali/saf/score/get',
    method: 'get',
    data: query
  })
}